import { ECounters } from 'affiny-core/modules/api/models/counters/counters.types';
import { ENotificationLabels } from 'affiny-core/modules/counters/types';
import { IRootState } from 'affiny-core/modules/state';
import { selectIsSub } from 'affiny-core/redux/selectors/subscriptionsSelectors';

/* ***** *****  Utils  ***** ***** */

const selectHasNewInteractions = (state: IRootState) =>
  !!selectCounter(state, ECounters.FAVORITE) ||
  !!selectCounter(state, ECounters.VISIT);

const selectHasNewMessages = (state: IRootState) =>
  !!selectCounter(state, ECounters.MESSAGE);

const selectHasNewPhotoRequests = (state: IRootState) =>
  !!selectCounter(state, ECounters.PHOTO_REQUEST);

/* ***** *****  Selectors  ***** ***** */

export const selectCounters = (state: IRootState) => state.counters;

export const selectCounter = (state: IRootState, counterKey: ECounters) =>
  state.counters[counterKey];

export const selectHasNotification = (
  state: IRootState,
  notificationLabel?: ENotificationLabels
): boolean => {
  switch (notificationLabel) {
    case ENotificationLabels.INTERACTIONS:
      return selectHasNewInteractions(state);
    case ENotificationLabels.MESSAGES:
      // if the user is reg, he should not see photo requests notifications
      return (
        selectHasNewMessages(state) ||
        (selectIsSub(state) && selectHasNewPhotoRequests(state))
      );
    default:
      return false;
  }
};
